<script lang="ts" setup>
const props = defineProps<{
  title: string
}>()
</script>

<template>
  <h2 class="font-pragmatica-ext mb-8 text-3xl font-bold md:text-4xl">
    {{ props.title }}
  </h2>
</template>
